<app-insights-panel></app-insights-panel>
